/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react-hooks/exhaustive-deps */
import "./signin.scss";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { appInsights } from "../../utils/AppInsights";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Link,
  Card as MuiCard,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WavingHandRoundedIcon from "@mui/icons-material/WavingHandRounded";
import { GoogleIcon, MicrosoftIcon } from "./CustomIcon";
import ForgotPassword from "./ForgotPassword";
import SignUp from "./SignUp";
import SignInWithOTP from "../signin/SignInWithOTP";
import SignInWithTwoFactorAuth from "../signin/SignInWithTwoFactorAuth";
import BackdropProgressBar from "../../components/ui/BackdropProgressBar";
import { ThemeProvider, styled } from "@mui/material/styles";
import theme from "../../assets/theme/theme";
import useApi from "../../hooks/useApi";
import {
  getIpAddress,
  createUserSession,
  refreshSessionIp,
  verifyUserSignIn,
  getSignUpAuthModeSettings,
  checkIsSessionLocked,
  getPortalIssueType,
  updateLoginTimeStamp,
  getEmployeeProfileImage,
} from "../../services/userService";
import { USERSIGNINMESSAGES, USERSIGNUPMESSAGES } from "../../constants/messages";
import {
  SIGNINRESPONSES,
  SIGNUPMODE,
  PASSWORDCHANGEMODE,
  OTPMODE,
  VERIFICATIONTYPE,
  USERINFO,
  LOCALSTORAGENAME,
  COOKIESNAME,
  GLOBALSETTINGS,
  SSO_URL,
  COMMONCONSTANTS,
  TOKEN,
  STATUS,
  AUDITRACEACTIONS,
  ACCOUNTLOCKKIND,
  AccountLockKind,
} from "../../data/constants";
import {
  resolveAccountLockKind,
  getAccountLockMessage,
  buildIncorrectPasswordMessage,
} from "../../utils/accountLockHelper";
import {
  UserSessionDto,
  VerifySignInDto,
  SignUpAuthModeSettingsDto,
  PortalIssueTypeDto,
  LoginTimeStampDto,
} from "../../types/User";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useUser } from "../../context/UserContext";
import { v4 as uuidv4 } from "uuid";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { setToken, shouldUseEmployeePhotoFallback } from "../../utils/commonHelper";
import { getDeviceType } from "../../utils/getDeviceType";
import Footer from "../../layouts/footer/Footer";
import { logAuditTrace } from "../../services/auditNavigationTraceService";
import { getCurrentESTTime } from "../../utils/dateHelper";
import { LoadingButton } from "@mui/lab";
import { getUserModuleRolePermissions } from "../../services/portalUserService";
import { UserModuleRolePermission } from "../../types/UserModuleRolePermission";
import EmployeeCheck from "../contacts/EmployeeCheck";
import { UserProfileDto } from "../../types/User";
import { getUserProfileInfo } from "../../services/userService";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ paddingTop: 1, paddingbo: 1 }}>{children}</Box>}
      </div>
    );
  },
  Card = styled(MuiCard)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    padding: theme.spacing(4),
    paddingTop: "0px",
    gap: theme.spacing(2),
    margin: "auto",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "450px",
    },
    boxShadow:
      "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
    ...theme.applyStyles("dark", {
      boxShadow:
        "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
    }),
  })),
  SignInContainer = styled(Stack)(({ theme }) => ({
    height: "calc((1 - var(100%, 0)) * 100dvh)",
    minHeight: "100%",
    padding: theme.spacing(2),
    paddingBottom: "45px",
    [theme.breakpoints.up("sm")]: {
      padding: "32px 32px 45px 32px",
    },
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      zIndex: -1,
      inset: 0,
      backgroundImage: "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
      backgroundRepeat: "no-repeat",
      ...theme.applyStyles("dark", {
        backgroundImage:
          "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
      }),
    },
  }));

export default function SignIn() {
  const { loading, executeApi } = useApi();

  const [authMode, setAuthMode] = useState({
    password: false,
    otp: false,
    authApp: false,
    passwordOrOTP: false,
    passwordOrAuthApp: false,
    passwordAndOTP: false,
    passwordAndAuthApp: false,
    name: "",
  });

  const [errors, setErrors] = useState({
    userInput: { error: false, message: "" },
    password: { error: false, message: "" },
  });

  const [formState, setFormState] = useState({
    userInput: "",
    password: "",
    showPassword: false,
    userId: 0,
    rememberMe: false,
  });
  const [otpSendTo, setOtpSendTo] = useState(OTPMODE.EMAIL);
  const [deviceId, setDeviceId] = useState("");
  const [passwordChangeMode, setPasswordChangeMode] = React.useState("");
  const [snackbarPassResetMsgOpen, setSnackbarPassResetMsgOpen] = useState<boolean>(false);
  const [requestFormSnackbarOpen, setrequestFormSnackbarOpen] = useState<boolean>(false);
  const [ssoSnackbarOpen, setSsoSnackbarOpen] = useState<boolean>(false);
  const [ssoSnackbarMsg, setSsoSnackbarMsg] = useState("");
  const initialized = useRef(false);
  const userInputTextFieldRef = useRef<HTMLInputElement>(null);
  const passwordTextFieldRef = useRef<HTMLInputElement>(null);
  const updateState = <T extends Record<string, unknown>>(
    setState: React.Dispatch<React.SetStateAction<T>>,
  ) => {
    return (newState: Partial<T>) => {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    };
  };
  const updateAuthModeState = updateState<typeof authMode>(setAuthMode);
  const updateErrorsState = updateState<typeof errors>(setErrors);
  const updateFormState = updateState<typeof formState>(setFormState);
  const { setUserId, setUserName, setFirstName, setLastName, setProfileImage } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (userInputTextFieldRef.current) {
      userInputTextFieldRef.current.focus();
    }
  }, []);

  const [open, setOpen] = React.useState(false);

  const [isSessionLocked, setIsSessionLocked] = React.useState(false);
  const [accountLockKind, setAccountLockKind] = React.useState<AccountLockKind>(
    ACCOUNTLOCKKIND.NONE,
  );
  const isAccountLocked = accountLockKind !== ACCOUNTLOCKKIND.NONE;
  const [isIpNotWhitelisted, setIsIpNotWhitelisted] = React.useState(false);
  const [isAccountExpired, setIsAccountExpired] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const [authModeSettings, setAuthModeSetings] = React.useState<SignUpAuthModeSettingsDto>({
    signUpMode: "",
    otpMode: "",
  });

  const [state, setState] = useState({
    issueTypeOptions: [] as PortalIssueTypeDto[],
  });
  const updateValue = (newState: Partial<typeof state>) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };
  useEffect(() => {
    const { errorMsg } = location.state || {};
    if (errorMsg) {
      setSsoSnackbarOpen(true);
      if (errorMsg === COMMONCONSTANTS.ROLE_NOT_FOUND) {
        setSsoSnackbarMsg(USERSIGNINMESSAGES.ROLE_NOT_ASSIGNED);
      } else if (errorMsg === COMMONCONSTANTS.USER_NOT_FOUND) {
        setSsoSnackbarMsg(USERSIGNUPMESSAGES.EMAIL_PHONE_DOES_NOT_EXIST);
      } else {
        setSsoSnackbarMsg(errorMsg);
      }
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location]);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setDeviceId(result.visitorId);
        if (result.visitorId && Cookies.get(COOKIESNAME.REMEMBERME) === "true") {
          updateFormState({
            userInput: Cookies.get(COOKIESNAME.USERINPUT),
            rememberMe: true,
          });
        }
      } catch (error) {
        appInsights?.trackException({
          exception: new Error(USERSIGNINMESSAGES.FINGERPRINT_ERROR_MESSAGES, error),
        });
      }
    };
    getFingerprint();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (localStorage.getItem(LOCALSTORAGENAME.INACTIVITY) === "true") {
      setSsoSnackbarOpen(true);
      setSsoSnackbarMsg(USERSIGNINMESSAGES.INACTIVITY_LOGOUT);
      localStorage.setItem(LOCALSTORAGENAME.INACTIVITY, "false");
    }
    const fetchIP = async () => {
      const ipAddress = await executeApi<string, string>(getIpAddress, "");
      let sessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);
      var newSessionValue = uuidv4();
      const userSessionData: UserSessionDto = {
        IpAddress: ipAddress,
        sessionValue: sessionValue,
        deviceType: getDeviceType(),
        newSessionValue: newSessionValue,
      };
      const latestSessionValue = await executeApi<UserSessionDto, string>(
        createUserSession,
        userSessionData,
      );
      localStorage.setItem(USERINFO.SESSIONVALUE, latestSessionValue);
      checkSessionLock();
    };
    if (!initialized.current) {
      initialized.current = true;
      fetchIP();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const authMode = await executeApi<string, SignUpAuthModeSettingsDto>(
        getSignUpAuthModeSettings,
        "",
      );
      setAuthModeSetings({
        signUpMode: authMode?.signUpMode,
        otpMode: authMode?.otpMode,
      });
      updateAuthModeState({ name: authMode?.signUpMode });
      if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD) {
        updateAuthModeState({ password: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_OTP) {
        updateAuthModeState({ otp: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_AUTHAPP) {
        updateAuthModeState({ authApp: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_OR_OTP) {
        updateAuthModeState({ passwordOrOTP: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_OR_AUTHAPP) {
        updateAuthModeState({ passwordOrAuthApp: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_OTP) {
        updateAuthModeState({ passwordAndOTP: true });
      } else if (authMode?.signUpMode === SIGNUPMODE.SIGNUP_WITH_PASSWORD_AND_AUTHAPP) {
        updateAuthModeState({ passwordAndAuthApp: true });
      }
      setOtpSendTo(authMode?.otpMode ?? "");
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkSessionLock = async () => {
    const result = await executeApi<string, boolean>(
      checkIsSessionLocked,
      localStorage.getItem(USERINFO.SESSIONVALUE),
    );
    setIsSessionLocked(result);
    localStorage.setItem(LOCALSTORAGENAME.ISSESSIONLOCKED, JSON.stringify(result));
  };
  useEffect(() => {
    const PortalIssueType = async () => {
      const issueType = await executeApi<string, PortalIssueTypeDto[]>(getPortalIssueType, "");
      if (issueType) {
        updateValue({ issueTypeOptions: issueType });
      }
    };
    PortalIssueType();
  }, []);
  const handleClickOpen = (mode: string) => {
    setPasswordChangeMode(mode);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    updateFormState({
      userInput: Cookies.get(COOKIESNAME.USERSIGNUPINPUT),
      password: "",
    });
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    setIsIpNotWhitelisted(false);
    setIsAccountExpired(false);
    updateErrorsState({
      userInput: { error: false, message: "" },
    });
    updateErrorsState({
      password: { error: false, message: "" },
    });
    setTabValue(newValue);
  };

  const validateInputs = () => {
    let isValid = true;
    if (!formState.userInput || formState.userInput.trim() === "") {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.USERINPUT_REQUIRED,
        },
      });
      if (userInputTextFieldRef.current) {
        userInputTextFieldRef.current.focus();
      }
      isValid = false;
    } else {
      updateErrorsState({
        userInput: { error: false, message: "" },
      });
    }

    if (!formState.password || formState.password.trim() === "") {
      updateErrorsState({
        password: {
          error: true,
          message: USERSIGNINMESSAGES.PASSWORD_REQUIRED,
        },
      });
      if (passwordTextFieldRef.current) {
        passwordTextFieldRef.current.focus();
      }
      isValid = false;
    } else {
      updateErrorsState({
        password: { error: false, message: "" },
      });
    }
    focusOnEmptyField();
    return isValid;
  };
  const focusOnEmptyField = () => {
    if (!formState.userInput) {
      userInputTextFieldRef.current?.focus();
    } else if (!formState.password) {
      passwordTextFieldRef.current?.focus();
    }
  };
  const [isLoginAction, setIsLoginAction] = useState(false);

  const handleSignIn = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!validateInputs()) return;

    try {
      setIsLoginAction(true);
      await verifySignIn();
    } finally {
      setIsLoginAction(false);
    }
  };

  const handleChildClick = (tabIndex: number) => {
    updateFormState({
      userInput: Cookies.get(COOKIESNAME.USERSIGNUPINPUT),
      password: "",
    });
    setTabValue(tabIndex);
  };

  const navigateToHomePage = async (userId: number) => {
    if (userId && userId > 0) {
      // A page the user was sent here FROM wins over the landing page. PrivateRoute puts it in
      // ?redirect= for every guarded route, but this used to be read only in the no-permissions
      // branch below - so anyone with a single module permission (i.e. every real user) was sent
      // to /Home instead, and the deep link they clicked was discarded. Epic 79824 AC1: opening
      // the emailed approval link unauthenticated must return to the sign screen after login.
      const requestedPath = searchParams.get("redirect") || location.state?.from?.pathname;
      if (requestedPath) {
        navigate(requestedPath, { replace: true });
        return;
      }

      const userModuleRolePermissions = await executeApi<number, UserModuleRolePermission[]>(
        getUserModuleRolePermissions,
        userId,
      );
      if (userModuleRolePermissions?.length > 0) {
        const homePage = userModuleRolePermissions.find((x) =>
          x.pageUrl?.includes(GLOBALSETTINGS.DEFAULT_PAGE),
        );
        if (homePage) {
          navigate(homePage.pageUrl, { replace: true });
        } else {
          const firstUrl = userModuleRolePermissions[0].pageUrl;
          navigate(firstUrl, { replace: true });
        }
      } else {
        const redirectPath =
          searchParams.get("redirect") ||
          location.state?.from?.pathname ||
          GLOBALSETTINGS.DEFAULT_PAGE;

        navigate(redirectPath, { replace: true });
      }
    }
  };

  async function initializeUserSession(): Promise<string> {
    const ipAddress = await executeApi<string, string>(getIpAddress, "");
    const sessionValue = localStorage.getItem(USERINFO.SESSIONVALUE);
    const newSessionValue = uuidv4();
    const userSessionData: UserSessionDto = {
      IpAddress: ipAddress,
      sessionValue: sessionValue,
      deviceType: getDeviceType(),
      newSessionValue: newSessionValue,
    };
    const latestSessionValue = await executeApi<UserSessionDto, string>(
      createUserSession,
      userSessionData,
    );
    localStorage.setItem(USERINFO.SESSIONVALUE, latestSessionValue);
    return latestSessionValue;
  }
  const verifySignIn = async () => {
    let session = localStorage.getItem(USERINFO.SESSIONVALUE);
    if (!session) {
      // No session yet: create one with the current IP.
      session = await initializeUserSession();
    } else {
      // Session already exists (created at page load). Re-evaluate the CURRENT client IP now,
      // so a network change since page load is caught by the IP whitelist check at login time.
      const currentIp = await executeApi<string, string>(getIpAddress, "");
      if (currentIp) {
        await executeApi<{ sessionValue: string; IpAddress: string }, number>(refreshSessionIp, {
          sessionValue: session,
          IpAddress: currentIp,
        });
      }
    }
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    setIsIpNotWhitelisted(false);
    setIsAccountExpired(false);
    const userSessionData: VerifySignInDto = {
      userInput: formState.userInput,
      password: formState.password,
      sessionValue: session,
      rememberForDevice: formState.rememberMe,
      deviceId: deviceId,
      verificationType: VERIFICATIONTYPE.PASSWORD,
      isGetToken: true,
    };
    const result = await executeApi<VerifySignInDto, VerifySignInDto>(
      verifyUserSignIn,
      userSessionData,
    );
    // The sign-in call can fail (e.g. a transient network error while the connection is switching
    // networks) — executeApi returns null and already surfaced an error alert. Don't crash on it.
    if (!result) {
      return false;
    }
    if (result.result === SIGNINRESPONSES.VALID_USER && !result.isRoleExist) {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.ROLE_NOT_ASSIGNED,
        },
      });
    } else if (result.result === SIGNINRESPONSES.VALID_USER) {
      if (authMode.passwordAndOTP || authMode.passwordAndAuthApp) {
        return true;
      }
      onUpdateLoginTimeStamp(result.userId, null);
      setToken(result.authToken);
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);
      updateFormState({ userId: result.userId });
      localStorage.setItem(LOCALSTORAGENAME.DEVICEID, deviceId);
      localStorage.setItem(LOCALSTORAGENAME.REMEMBERME, formState.rememberMe.toString());
      localStorage.setItem(LOCALSTORAGENAME.ROLENAMES, result.roleNames);
      localStorage.setItem(LOCALSTORAGENAME.ISFIRSTTIMELOGIN, result.isFirstTimeLogin.toString());
      localStorage.setItem(LOCALSTORAGENAME.PHONENUMBER, result.cachedPhoneNumber?.toString());
      localStorage.setItem(LOCALSTORAGENAME.EMAILADDRESS, result.cachedEmailAddress?.toString());

      setUserId(result.userId);
      setUserName(result.userName);
      setFirstName(result.cachedFirstName);
      setLastName(result.cachedLastName);

      if (shouldUseEmployeePhotoFallback(result.profileImage)) {
        const empProfileImg = await executeApi<number, string>(
          getEmployeeProfileImage,
          result.userId,
        );
        if (empProfileImg) setProfileImage(empProfileImg);
      } else {
        // An empty string here means the photo was explicitly removed (Bug 79975); the store
        // normalises it to null so the initials avatar shows.
        setProfileImage(result.profileImage);
      }
      if (formState.rememberMe) {
        Cookies.set(COOKIESNAME.USERINPUT, formState.userInput, {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set(COOKIESNAME.USERID, result.userId.toString(), {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set(COOKIESNAME.REMEMBERME, formState.rememberMe.toString(), {
          expires: 365,
          secure: true,
          sameSite: "Strict",
        });
      } else {
        Object.keys(Cookies.get()).forEach((cookieName) => {
          Cookies.remove(cookieName);
        });
      }
      logAuditTrace(
        {
          userId: result.userId,
          objectType: AUDITRACEACTIONS.Login,
          objectId: result.userId,
          objectName: "User Id " + result.userId,
          action: AUDITRACEACTIONS.Login,
          navigationDateTime: getCurrentESTTime(),
        },
        null,
        true,
      );
      navigateToHomePage(result.userId);
    } else if (result.result === SIGNINRESPONSES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT) {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT,
        },
      });
    } else if (result.result === SIGNINRESPONSES.PASSWORD_NOT_SET) {
      setOpenConfirmation(true);
      return false;
    } else if (result.result === SIGNINRESPONSES.ACCOUNT_LOCKED) {
      setAccountLockKind(resolveAccountLockKind(result.isAdminLocked));
      return false;
    } else if (result.result === SIGNINRESPONSES.SESSION_LOCKED) {
      setIsSessionLocked(true);
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);
      localStorage.setItem(LOCALSTORAGENAME.ISSESSIONLOCKED, JSON.stringify(true));
      return false;
    } else if (result.result === SIGNINRESPONSES.INCORRECT_PASSWORD) {
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);
      updateErrorsState({
        password: {
          error: true,
          message: buildIncorrectPasswordMessage(result.remainingAttempts),
        },
      });
      return false;
    } else if (result.result === SIGNINRESPONSES.IP_NOT_WHITELISTED) {
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);
      setIsIpNotWhitelisted(true);
      return false;
    } else if (result.result === SIGNINRESPONSES.ACCOUNT_EXPIRED) {      
      setIsAccountExpired(true);
      return false;
    } else if (result.result === SIGNINRESPONSES.INVALID_USER) {
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);      
      updateErrorsState({
        userInput: { error: true, message: USERSIGNINMESSAGES.USERINPUT_VALID },
      });
      return false;
    }
  };
  const onUpdateLoginTimeStamp = async (userId: number, loginMode: string) => {
    const empAndOtpData: LoginTimeStampDto = {
      userId: userId,
      sessionValue: localStorage.getItem(USERINFO.SESSIONVALUE),
      loginMode: loginMode,
    };
    await executeApi<LoginTimeStampDto, boolean>(updateLoginTimeStamp, empAndOtpData);
  };
  const handleRememberMeChange = async () => {
    setFormState((prev) => ({ ...prev, rememberMe: !prev.rememberMe }));
  };
  useEffect(() => {
    const savedUsername = Cookies.get("remembered_username");
    if (savedUsername) {
      updateFormState({ userInput: savedUsername, rememberMe: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUserNameChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFormState({ userInput: event.target.value });
    if (event.target.value !== "") {
      updateErrorsState({
        userInput: { error: false, message: "" },
      });
    }
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    setIsAccountExpired(false);
  };
  const handleUPasswordChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFormState({ password: event.target.value });
  };

  const handleCheckIsValidUserFromOtp = (response: string, isAdminLocked?: boolean) => {
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    setIsIpNotWhitelisted(false);
    setIsAccountExpired(false);
    if (response === "") {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.USERINPUT_REQUIRED,
        },
      });
      if (userInputTextFieldRef.current) {
        userInputTextFieldRef.current.focus();
      }
    } else if (response === SIGNINRESPONSES.VALID_USER) {
      setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    } else if (response === SIGNINRESPONSES.ACCOUNT_LOCKED) {
      // The OTP / 2FA identity step forwards the reason from verify-sign-in. Their later
      // failure paths (verify-otp, increase-failed-attempts-count) return only a string, so
      // isAdminLocked is undefined there and this falls back to the neutral message.
      setAccountLockKind(resolveAccountLockKind(isAdminLocked));
    } else if (response === SIGNINRESPONSES.SESSION_LOCKED) {
      setIsSessionLocked(true);
      localStorage.setItem(LOCALSTORAGENAME.ISSESSIONLOCKED, JSON.stringify(true));
    } else if (response === SIGNINRESPONSES.INCORRECT_PASSWORD) {
      updateErrorsState({
        password: {
          error: true,
          message: USERSIGNINMESSAGES.INCORRECT_PASSWORD_MESSAGE,
        },
      });
    } else if (response === SIGNINRESPONSES.INVALID_USER) {
      updateErrorsState({
        userInput: { error: true, message: USERSIGNINMESSAGES.USERINPUT_VALID },
      });
    } else if (response === SIGNINRESPONSES.ROLE_NOT_ASSIGNED) {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.ROLE_NOT_ASSIGNED,
        },
      });
    } else if (response === SIGNINRESPONSES.IP_NOT_WHITELISTED) {
      setIsIpNotWhitelisted(true);
    } else if (response === SIGNINRESPONSES.ACCOUNT_EXPIRED) {
      setIsAccountExpired(true);
    } else if (response === SIGNINRESPONSES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT) {
      updateErrorsState({
        userInput: {
          error: true,
          message: USERSIGNINMESSAGES.ALREADY_REGISTRED_WITH_PRIMARY_ACCOUNT,
        },
      });
    }
  };
  const handleActionFromOtp = async () => {
    if (validateInputs()) {
      return verifySignIn();
    }
    return false;
  };

  const onPasswordUpdateComplete = (response: boolean) => {
    if (response === true) {
      setSnackbarPassResetMsgOpen(true);
    }
  };
  const handleConfirmationClose = () => {
    setOpenConfirmation(false);
  };
  const handleConfirmationYesClicked = () => {
    setOpenConfirmation(false);
    handleClickOpen(PASSWORDCHANGEMODE.SETUP_PASSWORD);
  };
  const handleIsSessionLocked = () => {
    setIsSessionLocked(true);
    localStorage.setItem(LOCALSTORAGENAME.ISSESSIONLOCKED, JSON.stringify(true));
  };
  const handleSnackbarClose = () => setSnackbarPassResetMsgOpen(false);

  const microsoftLoginSso = async () => {
    LoginSsoWithPopUp(SSO_URL.MICROSOFT);
  };
  const googleLoginSso = async () => {
    LoginSsoWithPopUp(SSO_URL.GOOGLE);
  };
  const LoginSsoWithPopUp = (url: string) => {
    const width = 600;
    const height = 700;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(url, "SsoLogin", `width=${width},height=${height},top=${top},left=${left}`);
    const handleMessage = async (event) => {
      if (event.origin !== window.location.origin) return; // Security check
      if (event.data?.status === STATUS.SUCCESS) {
        localStorage.setItem(TOKEN.ACCESSTOKEN, event.data.token);
        localStorage.setItem(TOKEN.REFRESHTOKEN, event.data.refreshToken);
        localStorage.setItem(LOCALSTORAGENAME.ROLENAMES, event.data.roleNames);
        //setProfileImage(event.data.profileImage);
        setUserId(parseInt(event.data.userId));
        onUpdateLoginTimeStamp(parseInt(event.data.userId), COMMONCONSTANTS.SSO);
        let userNameValue = event.data.userName;
        if (!userNameValue || userNameValue.trim() === "") {
          userNameValue = `${event.data.firstName ?? ""}${event.data.lastName ?? ""}`.trim();
        }
        setUserName(userNameValue);
        setFirstName(event.data.firstName);
        setLastName(event.data.lastName);

        const res = await executeApi<number, UserProfileDto>(
          getUserProfileInfo,
          parseInt(event.data.userId),
        );
        if (res?.profileImage) {
          setProfileImage(res.profileImage);
        } else if (shouldUseEmployeePhotoFallback(res?.profileImage)) {
          const empProfileImg = await executeApi<number, string>(
            getEmployeeProfileImage,
            parseInt(event.data.userId),
          );
          if (empProfileImg) setProfileImage(empProfileImg);
        } else {
          // Photo explicitly removed (Bug 79975) - no HR photo fallback, show the initials avatar.
          setProfileImage(null);
        }
        navigateToHomePage(parseInt(event.data.userId));
      } else if (event.data?.status === STATUS.ERROR) {
        if (event.data.responseMessage) {
          setSsoSnackbarOpen(true);
          if (event.data.responseMessage === COMMONCONSTANTS.ROLE_NOT_FOUND) {
            setSsoSnackbarMsg(USERSIGNINMESSAGES.ROLE_NOT_ASSIGNED);
          } else if (event.data.responseMessage === COMMONCONSTANTS.USER_NOT_FOUND) {
            setSsoSnackbarMsg(USERSIGNUPMESSAGES.EMAIL_PHONE_DOES_NOT_EXIST);
          } else if (event.data.responseMessage === SIGNINRESPONSES.ACCOUNT_EXPIRED) {
            // SSO reports expiry through responseMessage rather than the verify-sign-in result, but the
            // API emits the same literal for both, so the one constant covers it.
            setSsoSnackbarMsg(USERSIGNINMESSAGES.ACCOUNT_EXPIRED_MESSAGE);
          } else {
            setSsoSnackbarMsg(event.data.responseMessage);
          }
          navigate("/signin");
        }
      }
      window.removeEventListener("message", handleMessage);
    };
    window.addEventListener("message", handleMessage);
  };

  const handleRequestFormSnackbarClose = () => setrequestFormSnackbarOpen(false);
  const handleSsoSnackbarClose = () => setSsoSnackbarOpen(false);
  const handleClickShowPassword = () => {
    updateFormState({ showPassword: !formState.showPassword });
  };
  const handleSetRoleStatus = async (response: string) => {
    updateErrorsState({
      userInput: { error: true, message: response },
    });
  };

  const renderPasswordField = (showButton = true) => (
    <>
      <FormControl>
        <TextField
          error={errors.password.error}
          helperText={errors.password.message}
          name="password"
          placeholder="••••••"
          type={formState.showPassword ? "text" : "password"}
          id="password"
          label="Password"
          autoComplete="new-password"
          required
          fullWidth
          value={formState.password}
          variant="outlined"
          color={errors.password.error ? "error" : "primary"}
          size="small"
          onChange={handleUPasswordChange}
          inputRef={passwordTextFieldRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={formState.showPassword ? "hide the password" : "display the password"}
                  onClick={handleClickShowPassword}
                  tabIndex={-1}
                >
                  {formState.showPassword ? (
                    <VisibilityOffOutlinedIcon fontSize="small" />
                  ) : (
                    <VisibilityOutlinedIcon fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
      {showButton && (
        <LoadingButton
          type="submit"
          fullWidth
          variant="contained"
          onClick={handleSignIn}
          loading={loading && isLoginAction}
          loadingPosition="start"
        >
          {loading && isLoginAction ? "Logging in..." : "Login"}
        </LoadingButton>
      )}
      {renderAuthLinks()}
    </>
  );

  const renderAuthLinks = () => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Link
        component="button"
        type="button"
        onClick={() => handleClickOpen(PASSWORDCHANGEMODE.FORGOT_PASSWORD)}
        variant="body2"
        sx={{ alignSelf: "center" }}
      >
        Reset/Forgot your password?
      </Link>

      {(otpSendTo === OTPMODE.EMAIL || otpSendTo === OTPMODE.SMS || OTPMODE.TWOFA) && (
        <ForgotPassword
          open={open}
          handleClose={handleClose}
          otpSendTo={otpSendTo}
          mode={passwordChangeMode}
          onPasswordUpdateComplete={onPasswordUpdateComplete}
          userInputValue={formState.userInput}
          onIsSessionLocked={handleIsSessionLocked}
        />
      )}
    </Box>
  );

  const renderOtpField = (Component, headerText = "") => (
    <Component
      onCheckIsValidUser={handleCheckIsValidUserFromOtp}
      onParentAction={handleActionFromOtp}
      userInput={formState.userInput}
      otpSendTo={otpSendTo}
      headerText={headerText}
      rememberForDevice={formState.rememberMe}
      deviceId={deviceId}
      onIsSessionLocked={handleIsSessionLocked}
      authModeName={authMode.name}
      onCallParentToRoleStatus={handleSetRoleStatus}
    />
  );
  const handleSignUpClick = (event) => {
    event.preventDefault();
    setAccountLockKind(ACCOUNTLOCKKIND.NONE);
    setTabValue(1);
  };
  return (
    <ThemeProvider theme={theme}>
      <input type="hidden" id="hdnAuthMode" value={authModeSettings.signUpMode} />
      <SignInContainer direction="column" justifyContent="space-between" className="signin-bg">
        <BackdropProgressBar loading={loading && !isLoginAction} />
        <div className="text-center mb-4 logo-wrap">
          <img src="/logo-transparent.svg" alt="logo" className="signin-logo" />
        </div>
        <Box className="login-container">
          <Card variant="outlined">
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              centered
              textColor="primary"
              indicatorColor="primary"
              variant="fullWidth"
            >
              <Tab label="Login" disabled={isSessionLocked} />
              <Tab label="Sign Up" disabled={isSessionLocked} id="tabSignUp" />
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <div className="signup-min-height">
                <Typography
                  component="h1"
                  variant="h4"
                  sx={{
                    fontSize: "22px",
                    fontWeight: "600",
                    marginBottom: "23px",
                    marginTop: "7px",
                  }}
                >
                  Hi, Welcome Back! <WavingHandRoundedIcon color="primary" />
                </Typography>

                {isSessionLocked && (
                  <Alert
                    severity="error"
                    sx={{ marginBottom: "10px" }}
                    className="alert-alert alert-alert-margin"
                  >
                    {USERSIGNINMESSAGES.SESSION_LOCKED_MESSAGE.replace(
                      "{Session_value}",
                      localStorage.getItem(USERINFO.SESSIONVALUE),
                    )}
                  </Alert>
                )}
                {isAccountLocked && (
                  <Alert
                    severity={
                      accountLockKind === ACCOUNTLOCKKIND.FAILED_ATTEMPTS ? "warning" : "error"
                    }
                    sx={{ marginBottom: "10px" }}
                    className="alert-alert alert-alert-margin"
                  >
                    {getAccountLockMessage(accountLockKind)}
                  </Alert>
                )}
                {isIpNotWhitelisted && (
                  <Alert
                    severity="error"
                    sx={{ marginBottom: "10px" }}
                    className="alert-alert alert-alert-margin"
                  >
                    {USERSIGNINMESSAGES.IP_NOT_WHITELISTED}
                  </Alert>
                )}
                {isAccountExpired && (
                  <Alert
                    severity="error"
                    sx={{ marginBottom: "10px" }}
                    className="alert-alert alert-alert-margin"
                  >
                    {USERSIGNINMESSAGES.ACCOUNT_EXPIRED_MESSAGE}
                  </Alert>
                )}
                <div className={isSessionLocked ? "disabled-div" : ""}>
                  <fieldset
                    disabled={isSessionLocked}
                    className={`rounded-lg ${isSessionLocked ? "opacity-50 blur-sm" : ""}`}
                  >
                    <Box
                      component="form"
                      noValidate
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: "14px",
                        padding: "0px",
                      }}
                    >
                      <FormControl>
                        <TextField
                          error={errors.userInput.error}
                          helperText={errors.userInput.message}
                          id="userInput"
                          type="text"
                          name="userInput"
                          label="Email or Phone or Username"
                          autoFocus
                          required
                          fullWidth
                          variant="outlined"
                          color={errors.userInput.error ? "error" : "primary"}
                          size="small"
                          value={formState.userInput}
                          onChange={handleUserNameChange}
                          inputRef={userInputTextFieldRef}
                        />
                      </FormControl>
                      <Box display="flex" alignItems="center">
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="remember"
                              color="primary"
                              checked={formState.rememberMe}
                              onChange={handleRememberMeChange}
                              className="py-0"
                              disableRipple
                            />
                          }
                          label="Remember me"
                        />
                      </Box>
                      {authMode.password && renderPasswordField()}
                      {authMode.otp && renderOtpField(SignInWithOTP)}
                      {authMode.authApp && renderOtpField(SignInWithTwoFactorAuth)}
                      {authMode.passwordOrOTP && (
                        <>
                          {renderPasswordField()}
                          <Divider>OR</Divider>
                          {renderOtpField(SignInWithOTP)}
                        </>
                      )}
                      {authMode.passwordOrAuthApp && (
                        <>
                          {renderPasswordField()}
                          <Divider>OR</Divider>
                          {renderOtpField(SignInWithTwoFactorAuth)}
                        </>
                      )}
                      {authMode.passwordAndOTP && (
                        <>
                          {renderPasswordField(false)}
                          {renderOtpField(SignInWithOTP, "And")}
                        </>
                      )}
                      {authMode.passwordAndAuthApp && (
                        <>
                          {renderPasswordField(false)}
                          {renderOtpField(SignInWithTwoFactorAuth, "And")}
                        </>
                      )}
                      <Divider>or</Divider>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color={"secondary"}
                          onClick={() => googleLoginSso()}
                          startIcon={<GoogleIcon />}
                          className="sign-in-btn"
                        >
                          <Typography variant="h6">Continue with Google</Typography>
                        </Button>
                        <Button
                          fullWidth
                          variant="outlined"
                          color={"secondary"}
                          onClick={microsoftLoginSso}
                          startIcon={<MicrosoftIcon />}
                          className="sign-in-btn"
                        >
                          <Typography variant="h6" className="microsoft-button-margin">
                            Continue with Microsoft
                          </Typography>
                        </Button>
                      </Box>
                      <Typography sx={{ textAlign: "center", fontSize: "14px" }}>
                        Don&apos;t have an account?{" "}
                        <Link
                          href="/signup"
                          variant="body2"
                          sx={{ alignSelf: "center" }}
                          onClick={handleSignUpClick}
                        >
                          Sign up
                        </Link>
                      </Typography>
                      <EmployeeCheck isSignin={true} />
                    </Box>
                  </fieldset>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <div className="signup-min-height">
                <SignUp
                  onTabClick={handleChildClick}
                  onIsSessionLocked={handleIsSessionLocked}
                  authModeSettings={authModeSettings}
                  issueType={state.issueTypeOptions}
                />
              </div>
            </TabPanel>
          </Card>
        </Box>

        <Snackbar
          open={snackbarPassResetMsgOpen}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={15000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            {USERSIGNINMESSAGES.PASSWORD_RESET_MESSAGE}
          </Alert>
        </Snackbar>
        <Snackbar
          open={requestFormSnackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          onClose={handleRequestFormSnackbarClose}
        >
          <Alert onClose={handleRequestFormSnackbarClose} severity="success">
            {USERSIGNINMESSAGES.AZURE_ACCOUNT_NOTFOUND_MESSAGE}
          </Alert>
        </Snackbar>
        <Snackbar
          open={ssoSnackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          onClose={handleSsoSnackbarClose}
        >
          <Alert
            onClose={handleSsoSnackbarClose}
            severity="error"
            sx={{ backgroundColor: "#FF0000", color: "#fff" }}
          >
            {ssoSnackbarMsg}
          </Alert>
        </Snackbar>
        <Dialog
          open={openConfirmation}
          onClose={handleConfirmationClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" className="dialogtitle-font-size">
            {"Password not set"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleConfirmationClose}
            sx={() => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: "#fff",
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>Do you want to set up your password?</Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleConfirmationClose} color="light" variant="contained">
              No
            </Button>
            <Button onClick={handleConfirmationYesClicked} autoFocus variant="contained">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </SignInContainer>
      <Footer />
    </ThemeProvider>
  );
}
